module.exports = __webpack_public_path__ + "img/sellerjoinin_back.8407d04a.png";